import React from "react";
import { Link, useRouteError } from "react-router-dom";
import "./Error.scss";
import Error from "../../assets/svg/error.svg";

const ErrorPage = () => {
  const error = useRouteError();
  console.log(error);

  if (error.status === 404) {
    return (
      <section className="error">
        <article className="error__container">
          <img src={Error} alt="Error" />

          <h3>{error.error.message || "This page cannot be accessed"}</h3>
          <div className="error__footer">
            <Link to="/">
              <button type="button" className="error-btn">
                Go Back
              </button>
            </Link>
          </div>
        </article>
      </section>
    );
  }

  return (
    <section className="error">
      <article className="error__container">
        <img src={Error} alt="Error" />

        <div className="error__footer">
          <Link to="/">
            <button type="button" className="error-btn">
              Go Back
            </button>
          </Link>
        </div>
      </article>
    </section>
  );
};

export default ErrorPage;
